export class EnaioAddonAddVbs {
    scriptName = "";
}
